import { render, staticRenderFns } from "./DashboardSkeltonLoader.vue?vue&type=template&id=0c79b8c9"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports